const getBaseUrl = (p) => {
    let path = p.getURLPath();
    return `/${path[0]}/${path[1]}`;
}

const getPlanPath = (p) => {
    let path = p.getURLPath();
    return `/${path[0]}/${path[1]}/${path[2]}`;
}

const getUsername = (p) => {
    return p.getURLPath()[0];
}

const getPlanSlug = (p) => {
    return p.getURLPath()[2];
}

const isNewPlan = (p) => {
    return p.getURLPath()[1] == 'new';
}

const windowResized = (provider) => {
    provider.p.resizeCanvas(provider.p.windowWidth, provider.p.windowHeight - 7);
    provider.sideBar.resizeWindow();
    provider.zoomMenu.position();
    provider.speciesInfo.reposition();
}

const getTimestamp = () => {
    return Math.floor(Date.now() / 1000);
}

const updateUnitSystem = (provider) => {
    provider.grid?.recalculate();
    let unitLabel = provider.settings.metric ? ' (m)' : ' (ft)';
    provider.units.map(unit => unit.html(unitLabel));
}

const focusInput = (input) => {
    if (input && input.visible) {
        // make sure the hot key is not entered in input
        setTimeout(
            () => input.focus(),
            10
        );
    }
}

const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const normalizeAngle = (angle) => {
    return angle % (Math.PI * 2);
}

export { getBaseUrl, getUsername, getPlanSlug, isNewPlan, windowResized, getTimestamp, updateUnitSystem, focusInput, capitalize, getPlanPath, normalizeAngle };
